module.exports = __webpack_public_path__ + "img/good0.2bc23761.png";